import Topbar from '@components/topbar';
import React from 'react';
import { ContentSC, FooterSC, OnboardingLayoutSC } from './onboarding-layout.styled';

interface OnboardingLayoutProps {
  children?: React.ReactNode;
  footer?: React.ReactNode;
}

const OnboardingLayout: React.FunctionComponent<OnboardingLayoutProps> = ({ children, footer }) => {
  return (
    <OnboardingLayoutSC type="default" variant="background">
      <Topbar authorized={false} />
      <ContentSC variant="baseline">{children}</ContentSC>
      {footer ? <FooterSC>{footer}</FooterSC> : null}
    </OnboardingLayoutSC>
  );
};

export default OnboardingLayout;
